// How to filter tasks
// Incomplete - not done
export const INCOMPLETE_TASKS = 'INCOMPLETE_TASKS';
// Complete - Done
export const COMPLETED_TASKS = 'COMPLETED_TASKS';
// All - Completed and Incomplete
export const ALL_TASKS = 'ALL_TASKS';
